/**
 * リクエストファイルアップロード時の確認ダイアログ
 * -ファイル選択から読み込みまででエラーが発生した場合
 */

import { Button, Popup, Title } from 'common/components';
import { FileLoadingErrorInfo } from 'common/modules/domain/deviceActivate';
import { BoardGL, Glossary } from 'common/utils/glossary';

// DEVICE_ACTIVATE_FILE_LOADING_ERROR_DISP

interface BoardProps {
  /** ReqFileLoadingErrorBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** 表示するメッセージ */
  fileLoadingErrorData: FileLoadingErrorInfo[];
  /** "閉じるボタン"(×)、"OKボタン"の処理の処理 */
  onClickClose: () => void;
}

export const ReqFileLoadingErrorBoard: React.FC<BoardProps> = ({
  isDisplay,
  glossary,
  fileLoadingErrorData,
  onClickClose
}) => {
  const _component = (
    <Popup
      className="reqFileLoadingErrorBoard-popup"
      onClickBackground={onClickClose}
      data-test="reqFileLoadingErrorBoard-popup"
      visible={isDisplay}
    >
      <div className="reqFileLoadingErrorBoard">
        <Button
          type="toolButton"
          subType="close"
          data-test="reqFileLoadingErrorBoard-toolButton"
          onClick={onClickClose}
        />
        <Title type="title" data-test="reqFileLoadingErrorBoard-listMessage">
          <span
            className="errorIcon"
            data-test="reqFileLoadingErrorBoard-listMessage-errorIcon"
          />
          <p>{glossary.glx(BoardGL.ReqFileNotUpload)}</p>
        </Title>
        <div className="reqFileLoadingErrorBoard-responseContainer">
          {fileLoadingErrorData.map((file) => (
            <div
              className="reqFileLoadingErrorBoard-response"
              data-test="reqFileLoadingErrorBoard-response"
            >
              <div className="reqFileLoadingErrorBoard-fileName">
                <span
                  className="errorIcon"
                  data-test="reqFileLoadingErrorBoard-errorIcon"
                />
                <p>{file.fileName}</p>
              </div>
              <p>{file.message}</p>
            </div>
          ))}
        </div>
        <Button
          type="cancelButton"
          data-test="reqFileLoadingErrorBoard-closeButton"
          onClick={onClickClose}
          className="reqFileLoadingErrorBoard-closeButton"
        >
          {glossary.glx(BoardGL.ActivateBoardOK)}
        </Button>
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};

export default ReqFileLoadingErrorBoard;
